AccessController = App.loadClass 'admin::Angular/AccessController'

class exports.SmsLogController extends AccessController
    constructor: (@scope, @transitions, @data, @window, @http) ->
        super('sms_log', @http)

        @scope.title = 'SMS Log'
        @scope.fullpage = true
        @scope.displayedCollection = []

        @loadScopeData @data.getSmses(), 'smses'
            .then () =>
                angular.element(@window).trigger 'resize'
                true
